import React, { useState, useContext, useEffect, useMemo } from 'react';
import { Row, Col, FormGroup, Label, Card, CardBody, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { ExtratoContext } from '~/context/ExtratoContext';
import InputAutoSelect from '~/components/InputAutoSelect';
import { dataFinalAnteriorInicial } from '~/helpers/date';
import { toast } from 'react-toastify';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { LoaderMini } from '~/components/Loaders';
import ReactGA from 'react-ga4';
import { PedidoContext } from '../../../context/PedidoContext'

import { TextClick } from './styles';



export function FiltroPedidos(props) {
	const {
		user,
		isMobile,
		aba,
		filtroData,
		setFiltroData,
		setFiltroStatus,
		filtroStatus,
		setPagina,
		filtroPesquisa,
		setFiltroPesquisa,
		loadingLancamento,
		setLoadingLancamento
	} = props;
	const {
		getExport,
	} = useContext(PedidoContext);

	const {
		revendaHierarquiaList,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);

	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	});

	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});

	const [inputValue, setInputValue] = useState('');
	const [timer, setTimer] = useState(null);

	useEffect(() => {
		if(revendaHierarquiaList.length === 0){
			getHierarquiaByDoc(user.dados.documento)
		}
	}, []);

	useEffect(() => {
		if (dataRange.dateEnd !== '') {
			if (dataFinalAnteriorInicial(dataRange.dateInit, dataRange.dateEnd)) {
				toast.warning('Data final não pode ser anterior a data inicial');
				setDataRange({
					dateInit: '',
					dateEnd: '',
				});
				setParams({
					dateInit: moment().format('YYYY-MM-DD'),
					dateEnd: moment().format('YYYY-MM-DD'),
				});

			} else {
				updateDateFilter();
				handleFiltroGA4();
			}
		}
	}, [dataRange]);

	const handleChange = event => {
		setFiltroStatus(event.target.value);
		setPagina(1)
	};

	function handleClickDownloadLancamentoGA4() {
		ReactGA.event({
			category: "download_lancamentos_click",
			action: "Download Lançamentos",
			label: "Baixando planilha de lançamentos",
		});
	}

	function updateDateFilter() {
		const paramsTemp = [
			moment(dataRange.dateInit).format('YYYY-MM-DD'),
			moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		];

		setParams({
			dateInit: moment(dataRange.dateInit).format('YYYY-MM-DD'),
			dateEnd: moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		});
		// eslint-disable-next-line prettier/prettier

		setFiltroData(`&data_lancamento=${paramsTemp[0]}%7C${paramsTemp[1]}`);

		setPagina(1);
	}

	const inputChanged = e => {
		setPagina(1)
		setInputValue(e.target.value)
		clearTimeout(timer)

		const newTimer = setTimeout(() => {
			setFiltroPesquisa(e.target.value)
		}, 1000)

		setTimer(newTimer)
	}

	function handlerLimparFiltro() {
		setFiltroData('');
		setFiltroStatus('');
		setInputValue('');
		setFiltroPesquisa('');

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);
	}

	function extrairData() {
		getExport(
			'enviados',
			filtroData,
			filtroStatus,
			filtroPesquisa,
			params
		);
	}

	function handleFiltroGA4() {
		ReactGA.event({
			category: `filtro_${aba}_click`,
			action: `Filtro ${aba}`,
			label: `Filtrando ${aba}`,
		});
	}

	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data inicial"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block notranslate"
						selected={dataRange.dateInit}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateInit: value,
							})
						}
					/>
				</FormGroup>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						style={{borderRadius: "5px", height: '55px'}}
						placeholderText="Data final"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block w-100 notranslate"
						selected={dataRange.dateEnd}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateEnd: value,
							})
						}
					/>
				</FormGroup>
			</Col>
		</>
	)

	const options = useMemo(() =>[{"documento": "Todos","nome": ""}, ...revendaHierarquiaList], [revendaHierarquiaList]);
	const selectedValue = options.find(opt => opt?.nome === inputValue) || null;

	return (
		<Card
			style={{
				boxShadow: 'unset',
				borderRadius: '0px 18px 18px 18px',
			}}>
			<CardBody>
				<Row>
					<Col xs="12" md="12" lg="5">
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }}>Buscar</Label>
							{revendaHierarquiaList.length > 0 && (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria') ?
									<InputAutoSelect
										options={options}
										getOptionLabel={(item) => `${item?.documento  || ''}${item?.documento && item?.nome ? ' - ' : ''}${item?.nome  || ''}` || ''}
										isOptionEqualToValue={(option, valueSelect) => option?.documento === valueSelect}
										value={selectedValue}
										onChangeOption={(evt, select) => {
											inputChanged({target: {value: select?.nome}} || {target: {value: ''}})
										}}
									/>
								:
									<Input
										type="text"
										placeholder='Nome ou referência do pedido'
										value={inputValue}
										onChange={inputChanged}
										style={{borderRadius: "5px", height: '55px'}}
									/>
							}
						</FormGroup>
					</Col>
					<Col xs="12" md="6" lg="5">
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }} className="d-block notranslate">Filtrar por data</Label>
							{!isMobile ?
								<Row>
									{ColData}
								</Row>
								: <>{ColData}</>
							}
						</FormGroup>
					</Col>
					<Col xs="12" md="12" lg="2">
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }}>Organizar por:</Label>
							<Input
								type="select"
								value={filtroStatus}
								onChange={handleChange}
								style={{borderRadius: "5px", height: '55px'}}
							>
								<option value="">
									Todos
								</option>
								<option value="APROVADO">
									Aprovado
								</option>
								<option value="REPROVADO">
									Reprovado
								</option>
								<option value="PENDENTE">
									Pendente
								</option>
							</Input>
						</FormGroup>
					</Col>
					<Col xs="12" md="12" lg="12">
						<button
							style={{ all: 'unset', cursor: 'pointer', color: '#333333', float: 'right' }}
							type='button'
							onClick={() => handlerLimparFiltro()}>
							<ClearIcon style={{ color: '#0AD6EA' }} />
							{' '}
							Limpar Filtros
						</button>
						{/* {user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
							<> */}
						{((user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || (user.dados.cargo.toLowerCase() === 'industria' && user.dados.permissoes.view_labels_pgm_triplo) || (user.dados.cargo.toLowerCase() === 'industria' && user.dados.tipo_projeto.toLowerCase() === 'intelbras')) && (aba === 'lancamentos')) &&
							(
								<div style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}>
									{
										!loadingLancamento ? (
											<TextClick
												style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}
												onClick={() => {
													setLoadingLancamento(true);
													extrairData();
													handleClickDownloadLancamentoGA4();
												}}
												tabIndex="0"
												role="button"
											>
												<CloudDownloadOutlined className="mr-1" />
												Fazer Download
											</TextClick>
										) : (
											<LoaderMini />
										)}
								</div>)
						}
						{/* </>
						} */}
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
}
